import * as Sentry from "@sentry/react";
import React from "react";

import CompanyMeetingsCoverage from "./components/CompanyMeetingsCoverage";

const CompanyMeetingsCoveragePage = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<CompanyMeetingsCoverage />
		</Sentry.ErrorBoundary>
	);
};

export default CompanyMeetingsCoveragePage;
